import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Certification } from './../_models/certification';

@Injectable()
export class CertificationService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getCertifications(): Observable<Certification[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/certifications')
      .pipe(map((response) => response));
  }

  getCertification(id: number): Observable<Certification> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/certifications/' + id)
      .pipe(map((response) => response));
  }

  saveCertification(certificationItem): Observable<Certification> {
    const certification = { ...certificationItem };
    // Rimuovi lastUpdated e dateCreated dalla certification
    delete certification.lastUpdated;
    delete certification.dateCreated;

    // Ottieni l'ID dell'azienda selezionata dal localStorage
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    certification.companyId = companySelected ? companySelected.id : null;

    // Se l'utente è definito, imposta solo l'ID dell'utente nella certification
    if (certification.user && certification.user.id) {
      certification.user = { id: certification.user.id };
    }

    // Se certification ha un ID, effettua una richiesta PUT per aggiornare la certification esistente
    if (certification.id) {
      return this.http
        .put<Certification>(
          `${this.apiBaseUrl}api/private/v1/certifications/${certification.id}`,
          certification
        )
        .pipe(map((response) => response as Certification));
    } else {
      // Altrimenti, effettua una richiesta POST per creare una nuova certification
      return this.http
        .post<Certification>(`${this.apiBaseUrl}api/private/v1/certifications`, certification)
        .pipe(map((response) => response as Certification));
    }
  }

  deleteCertification(id: number): Observable<Certification> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/certifications/' + id).pipe(
      map((response) => {
        return { id } as Certification;
      })
    );
  }
}
